module.exports = __webpack_public_path__ + "media/images/underline-51bd7eec.svg";